import React from 'react';
import { Table } from 'react-bootstrap';
import ActionIcon from 'src/components/general/ActionIcon';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { NumericFormat } from 'react-number-format';
import { formatterPeso, numberNegativeRed } from 'src/utils/utils';

export const PayrollNewTableConcepts = ({
    liquidationList,         // Lista de conceptos a mostrar
    totalAmount,            // Total calculado
    withValueLimitImports,  // Función para validar límites de importes
    setLiquidationList,     // Setter para actualizar la lista de conceptos
}) => {

    const handleRemoveConcept = (id) => {
        const newConceptsList = (liquidationList || []).filter(item => item?.id !== id);
        setLiquidationList(newConceptsList);
    };

    const handleImportAmountChange = (inputObj, id) => {
        const newConceptsList = liquidationList.map(item => {
            if (id === item?.id) {
                const periodAmount = inputObj?.floatValue ?? 0;
                return {
                    ...item,
                    periodAmount,
                    subtotalAmount: ((periodAmount || 0) - (item?.changeAmount || 0)).toFixed(2)
                };
            }
            return item;
        });
        setLiquidationList(newConceptsList);
    };

    const handleModificationAmount = (inputObj, id) => {
        const newConceptsList = liquidationList.map(item => {
            if (id === item?.id) {
                const changeAmount = inputObj?.floatValue ?? 0;
                return {
                    ...item,
                    changeAmount,
                    subtotalAmount: ((item?.periodAmount || 0) - (changeAmount || 0)).toFixed(2)
                };
            }
            return item;
        });
        setLiquidationList(newConceptsList);
    };

    return (
        <>
            <Table striped bordered hover size='sm'>
                <thead>
                    <tr>
                        <th className='text-center' style={{ "width": "25%" }}>Concepto</th>
                        <th className='text-center' style={{ "width": "10%" }}>Código</th>
                        <th className='text-center' style={{ "width": "20%" }}>Importe Período</th>
                        <th className='text-center' style={{ "width": "20%" }}>Modificaciones</th>
                        <th className='text-center' style={{ "width": "20%" }}>Subtotal</th>
                        <th className='text-center' style={{ "width": "5%" }}>Acciones</th>
                    </tr>
                </thead>
                <tbody className='text-black-color'>
                    {liquidationList?.map((item, index) => (
                        <tr key={item?.id || index}>
                            <td className='text-center'>
                                {item?.concept + "-" + item?.subConcept + "-" + item?.item}
                            </td>
                            <td className='text-center'>
                                {item?.code}
                            </td>
                            <td className='text-center'>
                                <NumericFormat
                                    prefix={'$'}
                                    className='form-control text-right'
                                    decimalScale={2}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    inputMode='numeric'
                                    value={item?.periodAmount ?? 0}
                                    placeholder="$0,00"
                                    allowLeadingZeros={false}
                                    isAllowed={(inputObj) => withValueLimitImports(inputObj)}
                                    onValueChange={(inputObject) => handleImportAmountChange(inputObject, item?.id)}
                                />
                            </td>
                            <td className='text-center'>
                                <NumericFormat
                                    prefix={'$'}
                                    className='form-control text-right'
                                    decimalScale={2}
                                    thousandSeparator={'.'}
                                    decimalSeparator={','}
                                    inputMode='numeric'
                                    value={item?.changeAmount ?? 0}
                                    placeholder="$0,00"
                                    allowLeadingZeros={false}
                                    allowNegative={true}
                                    isAllowed={(inputObj) => withValueLimitImports(inputObj)}
                                    onValueChange={(inputObject) => handleModificationAmount(inputObject, item?.id)}
                                />
                            </td>
                            <td className={`${numberNegativeRed(item?.subtotalAmount)} text-right`}>
                                {formatterPeso.format(item?.subtotalAmount || 0)}
                            </td>
                            <td className='text-center'>
                                <ActionIcon
                                    size='sm'
                                    icon={faMinusCircle}
                                    id='adduser'
                                    toolTipText='Remover'
                                    className='text-danger mr-2'
                                    onClick={() => handleRemoveConcept(item?.id)}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
            <div className='d-flex align-items-center mb-3'>
                <span className='ml-auto mr-0'>
                    <span className='text-black-color mr-3'>Total: </span>
                    <NumericFormat
                        prefix={'$'}
                        thousandSeparator={'.'}
                        decimalSeparator={','}
                        decimalScale={2}
                        value={totalAmount}
                        defaultValue={0}
                        className={'text-black-color text-right'}
                        readOnly
                    />
                </span>
            </div>
        </>
    );
};